var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10693 6.03549C9.10693 7.19949 8.16294 8.14282 6.99893 8.14282C5.83493 8.14282 4.8916 7.19949 4.8916 6.03549C4.8916 4.87082 5.83493 3.92749 6.99893 3.92749C8.16294 3.92749 9.10693 4.87082 9.10693 6.03549Z",
    stroke: "#23273B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99834 10.9032C9.53701 10.9032 11.859 9.0779 13.1663 6.03524C11.859 2.99257 9.53701 1.16724 6.99834 1.16724H7.00101C4.46234 1.16724 2.14034 2.99257 0.833008 6.03524C2.14034 9.0779 4.46234 10.9032 7.00101 10.9032H6.99834Z",
    stroke: "#23273B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.b6a94071a40e5a281f888731910662ca.svg";
export { ForwardRef as ReactComponent };